import { Component, Input, OnChanges, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { LoginPageResponse } from '../../../oauth/models/headless-cms/login-page-response';
import { LOGO } from '../../../core/models/logo.enum';
import { CompanyLogoService } from '../../../core/services/company-logo.service';
import { LoginPageApiService } from '../../../core/services/login-page-api.service';
import { DomainDataService } from 'src/app/core/services/domain-data.service';
import { LoginService } from 'src/app/core/services/login.service';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: "app-footer",
    templateUrl: "footer.component.html",
    styleUrls: ["footer.component.scss"],
    imports: [NgIf]
})
export class FooterComponent implements OnChanges {
  @Input()
  public loginChallenge;

  @Input()
  public domainName: string;

  public customerLogo = LOGO.CUSTOMER;
  public loginResponse: LoginPageResponse;
  public contactEmail: string;
  public logoSrc = null;
  public hrPolicyHref: string;
  public hrTermHref: string;
  private destroyRef = inject(DestroyRef);

  constructor(
    private _companyLogoService: CompanyLogoService,
    private _loginPageApiService: LoginPageApiService,
    private _domainDataService: DomainDataService,
    private _loginService: LoginService
  ) {
    this.serviceProvider = this.serviceProvider.bind(this);
    this.serviceProviderErrSubscriber = this.serviceProviderErrSubscriber.bind(
      this
    );
    this.hrPolicyHref = `${window.location.origin}/v2/static-content/privacy-policy`;
    this.hrTermHref = `${window.location.origin}/v2/static-content/terms-of-use`;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.loginChallenge || changes.domainName) {
      this._domainDataService.setDomainIfNotExists();
      this.loadLoginPageRes();
      this._companyLogoService
        .getCompanyLogo(this.loginChallenge, this.domainName, this.customerLogo)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(this.serviceProvider, this.serviceProviderErrSubscriber);
    }
  }

  private loadLoginPageRes() {
    this._loginPageApiService
      .getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.loginResponse = res;
        const { contactEmail } = this.loginResponse;
        this.contactEmail = `mailto:${contactEmail}`;
      });
  }

  private serviceProvider(res) {
    if (res && res.image) {
      this.logoSrc = `data:image/png;base64,${res.image}`;
    }
  }

  private serviceProviderErrSubscriber(err) {
    this.logoSrc = null;
  }
}